import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgRedis = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-redis';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M3.24 12v8.76h17.52V3.24H3.24zm16 0v7.24H4.76V4.76h14.48zM8.735 7.03l-.475.87-.947.18c-.521.099-.959.192-.973.206s.268.336.627.715c.452.477.657.721.665.794.006.058-.042.51-.108 1.005-.065.494-.112.906-.103.914.008.009.419-.176.912-.41l.897-.425.891.421c.49.232.9.413.911.401s-.037-.454-.107-.986l-.127-.966.271-.294c.149-.162.457-.492.685-.734.262-.279.394-.447.36-.458-.03-.01-.473-.094-.984-.188l-.931-.171-.469-.871c-.259-.479-.481-.871-.495-.872s-.239.39-.5.869m5.078 8.124-1.247 2.186 1.257.011c.691.005 1.821.005 2.511 0l1.255-.011-1.232-2.155a126 126 0 0 0-1.264-2.186c-.018-.018-.594.952-1.28 2.155m-5.209-1.971a2.2 2.2 0 0 0-.984.597c-.466.466-.667.948-.667 1.6 0 .668.202 1.147.684 1.624.598.591 1.347.8 2.139.597a2.2 2.2 0 0 0 1.064-.603c.549-.55.778-1.291.636-2.06-.15-.811-.834-1.545-1.641-1.76-.275-.073-.95-.07-1.231.005"
    })
  }));
});
export default SvgRedis;